import { store } from '@/store/store';

const api = {
    authenticate(email, password) {
        return new Promise((resolve, reject) => {
            this.apiClient()
                .post('/auth/obtain_token/', {
                    email: email,
                    password: password,
                })
                .then(response => {
                    store.dispatch('resetStore');
                    store.commit('updateToken', { token: response.data.token, refresh: response.data.refresh });
                    this.getProfileAndConsent()
                        .then(response => {
                            resolve(response);
                        })
                        .catch(error => {
                            console.debug(error);
                            reject(error);
                        });
                })
                .catch(error => {
                    console.debug(error);
                    reject(error);
                });
        });
    },

    refreshToken(refreshToken) {
        let refreshTokenToUse = refreshToken;
        if (refreshToken == null) {
            refreshTokenToUse = store.state.jwtRefresh;
        }
        this.apiClient()
            .post('/auth/refresh_token/', {
                refresh: refreshTokenToUse,
            })
            .then(response => {
                store.commit('updateToken', { token: response.data.token, refresh: response.data.refresh });
            })
            .catch(error => {
                console.debug(error);
                store.commit('removeToken');
                this.$router.push('AccountLogin');
            });
    },

    refreshTokenWithPromise(refreshToken) {
        let refreshTokenToUse = refreshToken;
        if (refreshToken == null) {
            refreshTokenToUse = store.state.jwtRefresh || localStorage.getItem('refreshToken');
        }
        return new Promise((resolve, reject) => {
            this.apiClient()
                .post('/auth/refresh_token/', {
                    refresh: refreshTokenToUse,
                })
                .then(response => {
                    store.commit('updateToken', { token: response.data.token, refresh: response.data.refresh });
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    logout() {
        store.commit('removeToken');
        localStorage.removeItem('refreshToken');
    },
};

export default api;
